import React from 'react'

function FooterExtraPage() {
  return (
    <section className="BottomIndexContainer">
        <div className="BottomMenuSection InterBoldTextFont">
            <div className="BottomMenuSectionWrapper BottomMenuGapWrapper" style={{ border: 0 }}>
                <div className="BottomPinginGoSectionWrapper">
                    <img src={process.env.PUBLIC_URL + "/Assets/images/Icon/pingingo-icon.svg"} className="PinginGoLogo" />
                    <div className="BottomMenuTextWrapper">
                        <p className="MidSizeText2 PoppinsLightTextFont">More Ping and Share, Endless Experience</p>
                        <div className="SocialMediaExtraPageWrapper">
                            <a href="https://www.facebook.com/profile.php?id=61562294233475">
                                <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/facebook-mitra.svg"} className="SocialIconButton Selectable2" style={{margin: 'auto'}}/>
                            </a>
                            <a href="https://twitter.com/Pingin_Go">
                                <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/twitter-mitra.svg"} className="SocialIconButton Selectable2" style={{margin: 'auto'}}/>
                            </a>
                            <a href="https://www.instagram.com/pingingo.official/">
                                <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/instagram-mitra.svg"} className="SocialIconButton Selectable2" style={{margin: 'auto'}}/>
                            </a>
                            <a href="https://www.tiktok.com/@pingingo.official">
                                <img src={process.env.PUBLIC_URL + "/Assets/images/ExtraPage/tiktok-mitra.svg"} className="SocialIconButton Selectable2" style={{margin: 'auto'}}/>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="BottomPinginGoSectionWrapper">
                    <p className="MidSizeText PoppinsBoldTextFont">Company</p>
                    <div className="BottomMenuTextWrapper FooterBottomTextWrapper">
                        <a className='AboutUsHref'>
                            <p className="MidSizeText2 HyperlinkUnderlineText PoppinsLightTextFont">About Us</p>
                        </a>
                        <a className='ContactUsHref'>
                            <p className="MidSizeText2 HyperlinkUnderlineText PoppinsLightTextFont">Contact Us</p>
                        </a>
                        <a className='TermsConditionHref'>
                            <p className="MidSizeText2 HyperlinkUnderlineText PoppinsLightTextFont">Terms & Condition</p>
                        </a>
                        <a className='PrivacyHref'>
                            <p className="MidSizeText2 HyperlinkUnderlineText PoppinsLightTextFont">Privacy</p>
                        </a>
                        <a className='FAQHref'>
                            <p className="MidSizeText2 HyperlinkUnderlineText PoppinsLightTextFont">FAQ</p>
                        </a>
                    </div>
                </div>
                <div className="BottomPinginGoSectionWrapper">
                    <p className="MidSizeText PoppinsBoldTextFont">Info</p>
                    <div className="BottomMenuTextWrapper FooterBottomTextWrapper">
                        <a href='https://blog.pingingo.com/tips-trick/registrasi-tanpa-ribet-pakai-referral/'>
                            <p className="MidSizeText2 HyperlinkUnderlineText PoppinsLightTextFont">How to booking</p>
                        </a>
                        <a className='ListingMitraHREF'>
                            <p className="MidSizeText2 HyperlinkUnderlineText PoppinsLightTextFont">Become a Mitra</p>
                        </a>
                        <a className='BlogHREF'>
                            <p className="MidSizeText2 HyperlinkUnderlineText PoppinsLightTextFont">Blog</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div className="BottomEndSection">
            <div className="BottomMenuSectionWrapper" style={{ display: "flex" }}>
                <p className="MidSizeText2 CopyRightTextMargin PoppinsLightTextFont">PinginGo© 2023 All rights reserved</p>
            </div>
        </div>
    </section>

  )
}

export default FooterExtraPage